/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/manager.ts"
/*!************************!*\
  !*** ./src/manager.ts ***!
  \************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   createScriptManager: () => (/* binding */ createScriptManager)
/* harmony export */ });
/* harmony import */ var _queue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./queue */ "./src/queue.ts");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var log = function log() {
};
var template = window.currentTemplate || 'default';
function createScriptManager(settings) {
  var _a, _b;
  var time = determineTime();
  var observer = null;
  var autoStopTimer;
  var isObserving = false;
  var eventsFired = false;
  var excludeRegex = ((_a = settings === null || settings === void 0 ? void 0 : settings.exclude) === null || _a === void 0 ? void 0 : _a.length) ? new RegExp(settings.exclude.join('|'), 'i') : null;
  var prioritizeRegex = ((_b = settings === null || settings === void 0 ? void 0 : settings.prioritize) === null || _b === void 0 ? void 0 : _b.length) ? new RegExp(settings.prioritize.join('|'), 'i') : null;
  var priorityScripts = [];
  var themeScripts = [];
  var thirdPartyScripts = [];
  var deferredScripts = [];
  var executedInlineScripts = new Set();
  function hashCode(str) {
    var hash = 5381;
    for (var i = 0; i < str.length; i++) {
      hash = hash * 33 ^ str.charCodeAt(i);
    }
    return hash >>> 0;
  }
  var queue = (0,_queue__WEBPACK_IMPORTED_MODULE_0__.createScriptQueue)(time, function () {
    if (eventsFired) return;
    eventsFired = true;
    log("Firing delayed events");
    document.dispatchEvent(new Event("DOMContentLoaded", {
      bubbles: true,
      cancelable: true
    }));
    window.dispatchEvent(new Event("load", {
      bubbles: true,
      cancelable: true
    }));
    window.dispatchEvent(new Event("resize", {
      bubbles: true,
      cancelable: true
    }));
  });
  function determineTime() {
    var windowWidth = window.innerWidth;
    var currentTemplate = template;
    var finalTime = 0;
    log("TEMPLATE:", currentTemplate);
    if (windowWidth <= 768) {
      finalTime = 100;
    }
    if (currentTemplate === 'collection') {
      finalTime = 700;
    }
    log("Final Time:", finalTime);
    return finalTime;
  }
  function isExcluded(src) {
    if (!src || !excludeRegex) return false;
    return excludeRegex.test(src);
  }
  function isPrioritized(src) {
    if (!src || !prioritizeRegex) return false;
    return prioritizeRegex.test(src);
  }
  function isThemeScript(src) {
    if (!src) return false;
    if (src.includes('/assets/')) return true;
    if (src.includes('cdn.shopify.com/s/files/')) return true;
    return false;
  }
  function isTarget(node) {
    var dataset = node.dataset,
      src = node.src;
    if (node.type === 'text/blocked') return false;
    var type = node.getAttribute('type');
    type = type ? type.toLowerCase().trim() : '';
    var validTypes = ['', 'text/javascript', 'application/javascript', 'module'];
    if (!validTypes.includes(type)) return false;
    if (dataset.optimized) return false;
    if (!src && node.innerHTML) {
      var content = node.innerHTML;
      if (content.includes('var Shopify =') || content.includes('window.Shopify')) {
        return false;
      }
    }
    if (src && isExcluded(src)) return false;
    return true;
  }
  function isBlocked(node) {
    var type = node.type,
      dataset = node.dataset;
    if (type !== 'text/blocked') return false;
    if (dataset.optimized) return false;
    return true;
  }
  function scriptStop(node) {
    var originalType = node.getAttribute('type') || '';
    node.dataset.originalType = originalType;
    node.type = 'text/blocked';
    if (node.src) {
      node.dataset.src = node.src;
      node.removeAttribute('src');
    }
    log("🛡️ STOP", node.dataset.src || 'inline');
  }
  function scriptInit(node) {
    return new Promise(function (resolve) {
      var originalType = node.dataset.originalType || 'text/javascript';
      var newNode = document.createElement('script');
      Array.from(node.attributes).forEach(function (attr) {
        if (attr.name !== 'type' && attr.name !== 'src') {
          newNode.setAttribute(attr.name, attr.value);
        }
      });
      newNode.dataset.optimized = 'true';
      newNode.type = originalType;
      if (node.dataset.src) {
        newNode.onload = function () {
          log("✅ LOADED", newNode.src);
          resolve();
        };
        newNode.onerror = function () {
          log("❌ FAILED (Network/CORS)", newNode.src);
          resolve();
        };
        newNode.src = node.dataset.src;
        newNode.async = false;
        newNode.defer = true;
      } else {
        var content = node.textContent || '';
        var hash = hashCode(content);
        if (executedInlineScripts.has(hash)) {
          log("⏭️ SKIPPED (Duplicate Inline)", "Hash: ".concat(hash));
          resolve();
          return;
        }
        executedInlineScripts.add(hash);
        newNode.textContent = content;
        setTimeout(resolve, 10);
      }
      if (node.parentNode) {
        node.parentNode.replaceChild(newNode, node);
      } else {
        document.head.appendChild(newNode);
        resolve();
      }
      log("🚀 INIT", newNode.src || 'inline');
    });
  }
  function handleMutations(mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeName === 'SCRIPT') {
          var scriptNode = node;
          if (isTarget(scriptNode)) {
            scriptStop(scriptNode);
          }
          if (isBlocked(scriptNode)) {
            var task = function task() {
              return scriptInit(scriptNode);
            };
            var src = scriptNode.dataset.src || '';
            if (isPrioritized(src)) {
              log("🔥 PRIORITY SCRIPT", src);
              priorityScripts.push(task);
            } else if (isThemeScript(src)) {
              log("🎨 THEME SCRIPT", src || 'inline');
              themeScripts.push(task);
            } else if (src && src.includes('app.js')) {
              log("⏳ DEFERRING (app.js)", src);
              deferredScripts.push(task);
            } else {
              log("📦 THIRD-PARTY", src || 'inline');
              thirdPartyScripts.push(task);
            }
          }
        }
      });
    });
  }
  function start() {
    var _this = this;
    if (isObserving) return;
    log("Starting observation...");
    observer = new MutationObserver(handleMutations);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
    isObserving = true;
    autoStopTimer = setTimeout(stop, 60e3);
    document.addEventListener('DOMContentLoaded', function () {
      log("Processing scripts...");
      log("  1. Priority (User):", priorityScripts.length);
      log("  2. Theme:", themeScripts.length);
      log("  3. Third-party:", thirdPartyScripts.length);
      log("  4. Deferred (app.js):", deferredScripts.length);
      var executeSequentially = function executeSequentially(tasks) {
        return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee() {
          var _iterator, _step, task, _t, _t2;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.p = _context.n) {
              case 0:
                _iterator = _createForOfIteratorHelper(tasks);
                _context.p = 1;
                _iterator.s();
              case 2:
                if ((_step = _iterator.n()).done) {
                  _context.n = 7;
                  break;
                }
                task = _step.value;
                _context.p = 3;
                _context.n = 4;
                return task();
              case 4:
                _context.n = 6;
                break;
              case 5:
                _context.p = 5;
                _t = _context.v;
                console.error("Critical Sequence Error:", _t);
              case 6:
                _context.n = 2;
                break;
              case 7:
                _context.n = 9;
                break;
              case 8:
                _context.p = 8;
                _t2 = _context.v;
                _iterator.e(_t2);
              case 9:
                _context.p = 9;
                _iterator.f();
                return _context.f(9);
              case 10:
                return _context.a(2);
            }
          }, _callee, null, [[3, 5], [1, 8, 9, 10]]);
        }));
      };
      executeSequentially([].concat(priorityScripts, themeScripts)).then(function () {
        log("Priority sequence finished. Ready for user interaction.");
        var triggerEvents = ['scroll', 'mousemove', 'touchstart', 'keydown'];
        var hasInteracted = false;
        var _onInteraction = function onInteraction() {
          if (hasInteracted) return;
          hasInteracted = true;
          log("User Interaction Detected! Starting queue for deferred scripts...");
          triggerEvents.forEach(function (evt) {
            return window.removeEventListener(evt, _onInteraction);
          });
          thirdPartyScripts.forEach(function (task) {
            return queue.add(task);
          });
          deferredScripts.forEach(function (task) {
            return queue.add(task);
          });
          queue.start();
        };
        triggerEvents.forEach(function (evt) {
          return window.addEventListener(evt, _onInteraction, {
            once: true,
            passive: true
          });
        });
      });
    });
  }
  function stop() {
    if (!isObserving) return;
    log("Stopping observation.");
    if (observer) {
      observer.disconnect();
      observer = null;
    }
    if (autoStopTimer) {
      clearTimeout(autoStopTimer);
      autoStopTimer = undefined;
    }
    isObserving = false;
  }
  return {
    start: start,
    stop: stop
  };
}

/***/ },

/***/ "./src/queue.ts"
/*!**********************!*\
  !*** ./src/queue.ts ***!
  \**********************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   createScriptQueue: () => (/* binding */ createScriptQueue)
/* harmony export */ });
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var log = function log() {
};
function createScriptQueue() {
  var delayTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 200;
  var onComplete = arguments.length > 1 ? arguments[1] : undefined;
  var queue = [];
  var isPaused = true;
  var isProcessing = false;
  function processQueue() {
    var _this = this;
    isPaused = false;
    isProcessing = true;
    log("Starting to process tasks (Idle Mode).");
    var _processNext = function processNext() {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee() {
        var currentTask, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (!(queue.length === 0)) {
                _context.n = 1;
                break;
              }
              isProcessing = false;
              log("All tasks finished.");
              if (onComplete) onComplete();
              return _context.a(2);
            case 1:
              currentTask = queue.shift();
              if (!currentTask) {
                _context.n = 5;
                break;
              }
              _context.p = 2;
              _context.n = 3;
              return currentTask();
            case 3:
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              console.error("TASK-QUEUE", "Error executing task:", _t);
            case 5:
              if (queue.length > 0) {
                if ('requestIdleCallback' in window) {
                  window.requestIdleCallback(_processNext, {
                    timeout: delayTime * 2
                  });
                } else {
                  setTimeout(_processNext, delayTime);
                }
              } else {
                isProcessing = false;
                log("All tasks finished.");
                if (onComplete) onComplete();
              }
            case 6:
              return _context.a(2);
          }
        }, _callee, null, [[2, 4]]);
      }));
    };
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(_processNext);
    } else {
      setTimeout(_processNext, 0);
    }
  }
  function start() {
    if (isPaused) {
      processQueue();
    }
  }
  function add(taskFunction) {
    if (typeof taskFunction !== 'function') {
      console.error("TASK-QUEUE", "Error: You must pass a function.");
    }
    queue.push(taskFunction);
    if (!isPaused && !isProcessing) {
      processQueue();
    }
  }
  return {
    add: add,
    start: start
  };
}

/***/ }

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Check if module exists (development only)
/******/ 		if (__webpack_modules__[moduleId] === undefined) {
/******/ 			var e = new Error("Cannot find module '" + moduleId + "'");
/******/ 			e.code = 'MODULE_NOT_FOUND';
/******/ 			throw e;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be isolated against other modules in the chunk.
(() => {
/*!*********************!*\
  !*** ./src/main.ts ***!
  \*********************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _manager__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./manager */ "./src/manager.ts");

var scriptManager = (0,_manager__WEBPACK_IMPORTED_MODULE_0__.createScriptManager)({
  exclude: ['slick', 'jquery', 'flickity', 'gsap', 'aos', 'custom', 'theme.js', 'micromodal', 'unpkg.com/micromodal', 'cdn.shopifycloud.com', 'connect.facebook.net', 'analytics.tiktok.com', 'stamped.io', 'accessibly.js'],
  prioritize: []
});
scriptManager.start();
})();

/******/ })()
;